import "./componets/asserts/css/style.css"
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./componets/partials/Navbar";
import Home from "./componets/Home";
import RoomPage from "./componets/RoomPage";
import Footer1 from "./componets/partials/Footer1";
import SignUp from "./componets/partials/SignUp";
import SignIn from "./componets/SignIn";

import SingleRoom from "./componets/SingleRoom";
import QueryForm from "./componets/partials/QueryForm";
import ContactUs from "./componets/ContactUs";
import CorporatePage from "./componets/CorporatePage";
import ScrollToTop from "./componets/partials/ScrollTop";
import CheckAvailbility from "./componets/CheckAvailbilty";
import DiningPage from "./componets/DiningPage";
import SingleDiningPage from "./componets/SingleDiningPage";
import Gallery from "./componets/Gallery";
import BanquetHallForm from "./componets/BanquetHallForm";
import CorporateQueryForm from "./componets/CorporateQueryForm";
import MenuPage from "./componets/MenuPage";
import ForgetPassword1 from "./componets/forget-password/ForgetPassword1";
import ForgetPassword2 from "./componets/forget-password/ForgetPassword2";
import ForgetPassword3 from "./componets/forget-password/ForgetPassword3";
import UserHomePage from "./componets/userPages/UserHomePage";
import { Toaster } from 'react-hot-toast';
import UpdateProfile from "./componets/userPages/UpdateProfile";
import Testimonial from "./componets/admin/testimonial/Testimonial";
import RoomCart from "./componets/admin/roomcart/RoomCart";
import CreateRoomCart from "./componets/admin/roomcart/CreateRoomCart";
import UpdateRoomCart from "./componets/admin/roomcart/UpdateRoomCart";
import Confirm from "./componets/admin/confirm/Confirm";
import Booking from "./componets/admin/booking/Booking";
import CreateTestimonils from "./componets/admin/testimonial/CreateTestimonils";
import Newsletter from "./componets/admin/newsletter/Newsletter";
import ContactUsAdmin from "./componets/admin/contact/ContactUsAdmin";
import BanquetQueryAdmin from "./componets/admin/banquetQueryPage/BanquetQueryAdmin";
import UpdateTestimonils from "./componets/admin/testimonial/UpdateTestimonils";
import User from "./componets/admin/user/User";

import CorporateQueryAdmin from "./componets/admin/corporateQueryPage/CorporateQueryAdmin";
import AeroStag from "./componets/dining-pages/AeroStag"
import BookingRoom from "./componets/BookingRoom";
import UserBookingPage from "./componets/userPages/UserBookingPage";
import UserOfferPage from "./componets/userPages/UserOfferPage";
import UserSupportPage from "./componets/userPages/UserSupportPage";
import CreateUserOffers from "./componets/admin/userOffers/CreateUserOffers";
import Offers from "./componets/admin/userOffers/Offers";
import Props from "./componets/Props";
import ConfirmPage from "./componets/ConfirmPage";
import RoomCard from "./componets/partials/RoomCard";
import ErrorPage from "./componets/ErrorPage";
import ConfirmPayment from "./componets/ConfirmPayment";
import AdminGallery from "./componets/admin/gallery/AdminGallery";
import CreateGallery from "./componets/admin/gallery/CreateGallery";
import UpdateGallery from "./componets/admin/gallery/UpdateGallery ";
import AllBookingShow from "./componets/admin/booking/AllBookingShow";
import PrivacyPolicy from "./componets/PrivacyPolicy";
import TermsandConditions from "./componets/TermsandConditions";
import CancellationandRefund from "./componets/CancellationandRefund";
import RouteChangeTracker from "./RouteChangeTracker";


// import Enquery from "./componets/admin/enquery/Enquery";
function App() {

  return (
    <>
    <BrowserRouter>
    <RouteChangeTracker/>
     <Navbar/>
     <ScrollToTop/>
     <Toaster />
      <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/signin" element={<SignIn/>}/>
          <Route path="/query" element={<QueryForm/>}/>
           <Route path="/banquet-query" element={<BanquetHallForm/>}/>
           <Route path="/corporate-query" element={<CorporateQueryForm/>}/>
          <Route path="/signup" element={<SignUp/>}/>
          <Route path="/corporate" element={<CorporatePage/>}/>
          <Route path="/contact-us" element={<ContactUs/>}/>
          {/* dining routes */}




      
          <Route path="/dine" element ={<AeroStag/>}/>
          <Route path ="/rooms" element={<RoomPage/>}/>
          <Route path ="/room" element={<SingleRoom/>}/>
          <Route path ="/menu" element={<MenuPage/>}/>

          <Route path ="/check-availability/:_id" element={<CheckAvailbility/>}/>
         
          <Route path="/allroom" element={<RoomCard/>}/>
          <Route path="/booking" element={<RoomCard/>}/>
          {/* <Route path ="/booking" element={<RoomTypePage/>}/> */}
          {/* <Route path ="/checkin" element={<BookingRoom/>}/> */}
          <Route path="/related-room" element={<RoomCard />}/>
        
          <Route path ="/booking/:_id" element={<BookingRoom/>}/>
          <Route path ="/444" element={<SingleRoom/>}/>
          
          <Route path ="/dining" element={<DiningPage/>}/>
          <Route path ="/explore-dining" element={<SingleDiningPage/>}/>
          <Route path ="/gallery" element={<Gallery/>}/>
          <Route path ="/forget1" element={<ForgetPassword1/>}/>
          <Route path ="/forget2" element={<ForgetPassword2/>}/>
          <Route path ="/forget3" element={<ForgetPassword3/>}/>
            {/* privacy policy */}
          <Route path ="/privacypolicy" element={<PrivacyPolicy/>}/>
          <Route path ="/termsandconditions" element={<TermsandConditions/>}/>
          <Route path ="/cancellationandrefund" element={<CancellationandRefund/>}/>


          {/* user Route */}
        {
          localStorage.getItem("login") ?
          <>
          <Route path ="/my-account" element={<UserHomePage/>}/>
          <Route path="/user-offer" element ={<UserOfferPage/>}/>
          <Route path="/user-support" element ={<UserSupportPage/>}/>
          <Route path="/payment/:_id>" element ={<ConfirmPayment/>}/>
          <Route path="/user-booking" element ={<UserBookingPage/>}/>
          <Route path="/confirmation" element ={<ConfirmPage/>}/>
          <Route path ="/update-profile" element={<UpdateProfile/>}/>
          </>
          :""
        }
          


           {
           
              localStorage.getItem("login") && localStorage.getItem("role")==="@A*_s&_k!=!@h!-%" ?

              <>
          <Route path ="/admin/testimonial" element={<Testimonial/>}/>
          <Route path ="/admin/roomcart" element={<RoomCart/>}/>
          <Route path ="/admin/roomcart/create" element={<CreateRoomCart/>}/>
          <Route path ="/admin/roomcart/update/:_id" element={<UpdateRoomCart/>}/>
          <Route path ="/admin/booking" element={<Booking/>}/>
          <Route path ="/admin/:_id" element={<AllBookingShow/>}/>
          <Route path ="/admin/confirm" element={<Confirm/>}/>
          <Route path ="/admin/offers" element={<Offers/>}/>
          <Route path ="/admin/create-offers" element={<CreateUserOffers/>}/>
          {/* < Route path ="/admin/offerUpdate/:id" element= {<OfferUpdate/>}/> */}
          {/* <Route path ="/admin/update-offers/:_id" element={<UpdateUserOffers/>}/> */}

          <Route path ="/admin/create-testimonial" element={<CreateTestimonils/>}/>
          <Route path ="/admin/update-testimonial/:id" element={<UpdateTestimonils/>}/>
          <Route path ="/admin/user" element={<User/>}/>
          <Route path ="/admin/newsletter" element={<Newsletter/>}/>
          <Route path ="/admin/contact" element={<ContactUsAdmin/>}/>
          
          <Route path ="/admin/corporate-query" element={<CorporateQueryAdmin/>}/>
          <Route path ="/admin/enquery" element={<BanquetQueryAdmin/>}/>
          <Route path ="/admin/enquery" element={<BanquetQueryAdmin/>}/>
          <Route path="/user-booking" element ={<UserBookingPage/>}/>
          <Route path="/user-offer" element ={<UserOfferPage/>}/>
          <Route path="/user-support" element ={<UserSupportPage/>}/>
          <Route path="/admin/gallery" element ={<AdminGallery/>}/>
          <Route path="/admin/create-gallery" element ={<CreateGallery/>}/>
          <Route path="/admin/update-gallery/:_id" element ={<UpdateGallery/>}/>
              </>
              :""

           }
          



          <Route path="/*" element={<ErrorPage/>}/>
          
          <Route path="/checkin" element ={<Props/>}/>
          <Route path="/confirmation" element ={<ConfirmPage/>}/>
          {/* <Route path="/payment/:_id>" element ={<ConfirmPayment/>}/> */}
          <Route path="/payment/:_id" element ={<ConfirmPayment/>}/>
          {/* <Route path='/user/payment/:_id' element={<ConfirmPayment/>}/> */}
      </Routes>

      
      <Footer1/>
    </BrowserRouter>
    </>
  );
}

export default App;